export default __webpack_public_path__ + "static/media/deer-color.412d51cf.png";